export interface StoreData {
    username?: string;
    email?: string;
    password?: string;
    confirmPassword?: string;
    country?: string;
    role?: string
  }
  
  export interface Store extends StoreData {
    errors: Partial<Record<keyof StoreData, string>>;
  }
  
  export const initStore: Store = {
    username: undefined,
    email: undefined,
    password: undefined,
    confirmPassword: undefined,
    country: undefined,
    role: undefined,
    errors: {},
  };
  
  type Action =
    | { action: keyof StoreData; payload?: string}
    | { action: 'reset'; payload?: any }
    | { action: 'errors'; payload: Partial<Record<keyof StoreData, string>> };
  export const reducer = (state: Store, act: Action) => {
    const { action } = act;
    if (action === 'reset') {
      return initStore;
    }
  
    return { ...state, [action]: act.payload };
  };
  